export enum Anonymity{
  Anonymous = 'Anonymous',
  None = 'None',
  SemiAnonymous = 'Semi-Anonymous'
}
